import { __decorate } from "tslib";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, Injector, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ServerInterceptor } from "./shared/services/service-interceptor/server-interceptor.service";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AppConfig } from "./app.config";
import { DashboardModule } from "./core/dashboard/dashboard.module";
import { SharedModule } from "./shared/shared.module";
import { AppControllerService } from "./app-controller.service";
import { FormErrorStateMatcher } from "./shared/classes/error-state-matcher";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { BackgroundPreloadService } from "./shared/services/background-preload/background-preload.service";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NavModule } from "./core/nav/nav.module";
import { OAuthModule } from "angular-oauth2-oidc";
import { AuthService } from "./shared/services/auth/auth.service";
import { NgbAccordionModule, NgbModule, NgbAccordionDirective } from "@ng-bootstrap/ng-bootstrap";
import { GlobalErrorHandler } from "./shared/classes/global-error-handler";
import { MobileConfigComponent } from "./core/mobile-config/mobile-config.component";
import { ApplyAccessComponent } from "./core/organisations/apply-access/apply-access.component";
import { APP_BASE_HREF, CommonModule, PlatformLocation } from "@angular/common";
import { ArcgisItemsComponent } from "./tabs/arcgis-items/arcgis-items.component";
import { LandingPageComponent } from "./core/landing-page/landing-page.component";
import { MatSliderModule } from "@angular/material/slider";
import { OrganisationConfigComponent } from "./core/organisation-config/organisation-config.component";
import { AddOrganisationConfigComponent } from "./core/organisation-config/add-organisation/add-organisation-config.component";
import { EditOrganisationConfigComponent } from "./core/organisation-config/edit-organisation/edit-organisation-config.component";
import { CreateMobileConfigComponent } from "./core/mobile-config/create-mobile-config/create-mobile-config/create-mobile-config.component";
import { EditMobileConfigComponent } from "./core/mobile-config/edit-mobile-config/edit-mobile-config/edit-mobile-config.component";
import { MapModule } from "./map/map.module";
import { PropertiesComponent } from "./tabs/properties/properties.component";
import { BaysComponent } from "./tabs/bays/bays.component";
import { GravesComponent } from "./tabs/graves/graves.component";
import { LocationSearchCemeteriesComponent } from "./tabs/graves/location-search-cemeteries/location-search-cemeteries.component";
import { NgPipesModule } from "ngx-pipes";
import { POIComponent } from "./tabs/poi/poi.component";
import { StreetsComponent } from "./tabs/streets/streets.component";
import { UnsecureCaptureCommentComponent } from "./unsecure/unsecure-capture-comment/unsecure-capture-comment.component";
import { UnsecureViewDocumentsComponent } from "./unsecure/unsecure-view-documents/unsecure-view-documents.component";
import { StoreModule } from "@ngrx/store";
import { applicationTabReducer, formGroupReducer, searchTypeReducer, tabChangedReducer } from "./store/reducers/tab-applications.reducer";
import { moduleChangedReducer, moduleInfoReducer } from "./store/reducers/module-info.reducer";
import { piErfNoReducer, piAlotmentReducer, piFarmNoReducer, piSGCodeReducer } from "./store/reducers/property-info.reducer";
import { arcgisItemsTabReducer } from "./store/reducers/tab-arcgis-items.reducer";
// import { TableModule } from "primeng/table";
import { FeatureSearchComponent } from "./search/feature-search/feature-search.component";
import { ApplicationSearchComponent } from "./search/application-search/application-search.component";
import { MatSelectModule } from "@angular/material/select";
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MaintenanceModeConfigComponent } from "./core/maintenance-mode-config/maintenance-mode-config.component";
export let AppInjector;
let AppModule = class AppModule {
    injector;
    constructor(injector) {
        this.injector = injector;
        AppInjector = this.injector;
    }
    static ctorParameters = () => [
        { type: Injector }
    ];
};
AppModule = __decorate([
    NgModule({
        declarations: [
            AppComponent,
            ApplyAccessComponent,
            ArcgisItemsComponent,
            LandingPageComponent,
            MobileConfigComponent,
            OrganisationConfigComponent,
            AddOrganisationConfigComponent,
            EditOrganisationConfigComponent,
            CreateMobileConfigComponent,
            EditMobileConfigComponent,
            PropertiesComponent,
            BaysComponent,
            GravesComponent,
            LocationSearchCemeteriesComponent,
            POIComponent,
            StreetsComponent,
            UnsecureViewDocumentsComponent,
            FeatureSearchComponent,
            ApplicationSearchComponent,
            FeatureSearchComponent,
            MaintenanceModeConfigComponent
        ],
        bootstrap: [AppComponent],
        imports: [CommonModule,
            BrowserModule,
            BrowserAnimationsModule,
            AppRoutingModule,
            AppRoutingModule,
            ServiceWorkerModule.register("ngsw-worker.js", { enabled: environment.production }),
            MatProgressSpinnerModule,
            MatDialogModule,
            MatInputModule,
            ReactiveFormsModule,
            FormsModule,
            MatIconModule,
            MatSidenavModule,
            MatToolbarModule,
            MatButtonModule,
            MatSelectModule,
            DashboardModule,
            SharedModule,
            MatBottomSheetModule,
            NavModule,
            OAuthModule.forRoot(),
            NgbModule,
            MatSliderModule,
            MapModule,
            NgPipesModule,
            NgbAccordionModule,
            NgbAccordionDirective,
            SignaturePadComponent,
            // TableModule,
            UnsecureCaptureCommentComponent,
            StoreModule.forRoot({
                applicationSearch: applicationTabReducer,
                applicationSearchType: searchTypeReducer,
                applicationFormGroup: formGroupReducer,
                applicationTabChanged: tabChangedReducer,
                arcgisItemSearch: arcgisItemsTabReducer,
                erfNo: piErfNoReducer,
                farmNo: piFarmNoReducer,
                allotment: piAlotmentReducer,
                sgCode: piSGCodeReducer,
                modulesId: moduleInfoReducer,
                modulesChanged: moduleChangedReducer
            }), NgMultiSelectDropDownModule],
        providers: [
            // Providing these two services like this here is done for a reason.
            // The Http interceptor needs them and the config.json file needs the interceptor
            // When the config is fetched the http interceptor hasn't received the services yet (they aren't loaded yet)
            AuthService,
            AppControllerService,
            { provide: HTTP_INTERCEPTORS, useClass: ServerInterceptor, multi: true },
            AppConfig,
            { provide: FormErrorStateMatcher, useClass: FormErrorStateMatcher },
            BackgroundPreloadService,
            WindowReference,
            { provide: ErrorHandler, useClass: GlobalErrorHandler },
            {
                provide: APP_BASE_HREF,
                useFactory: (s) => s.getBaseHrefFromDOM(),
                deps: [PlatformLocation]
            },
            provideHttpClient(withInterceptorsFromDi())
        ]
    })
], AppModule);
export { AppModule };
